import gql from 'graphql-tag';

// QUERIES
export const GET_OWNERS = gql`
  query getOwners {
    getOwners {
      id
      name
      email
      language
      nationality
      registrations {
        numberOfRegisteredArenas
        numberOfRegisteredRanges
        numberOfRegisteredEhubs
      }
    }
  }
`;

export const GET_UNREGISTERED_UNITS = gql`
  query getUnregisteredUnits($unitType: UnitType!) {
    getUnregisteredUnits(unitType: $unitType) {
      id
      statusJsonData {
        lastConnectedAt
        rangeInfo {
          name
          language
          timeZone
          installedReleaseBundle
        }
      }
    }
  }
`;

export const GET_OWNER = gql`
  query getOwner($id: ID!) {
    getOwner(id: $id) {
      id
      name
      email
      language
      nationality
      registrations {
        numberOfRegisteredArenas
        numberOfRegisteredRanges
        numberOfRegisteredEhubs
      }
    }
  }
`;

export const GET_OWNER_WITH_ARENAS = gql`
  query getOwner($id: ID!) {
    getOwner(id: $id) {
      id
      name
      email
      language
      nationality
      registrations {
        numberOfRegisteredArenas
        numberOfRegisteredRanges
        numberOfRegisteredEhubs
      }
      arenas {
        id
        name
      }
    }
  }
`;

export const GET_OWNER_WITH_ARENAS_AND_RANGES = gql`
  query getOwner($id: ID!) {
    getOwner(id: $id) {
      id
      name
      email
      language
      nationality
      registrations {
        numberOfRegisteredArenas
        numberOfRegisteredRanges
        numberOfRegisteredEhubs
      }
      arenas {
        id
        name
        ranges {
          id
          name
        }
      }
    }
  }
`;

export const GET_ARENAS = gql`
  query getArenas {
    getArenas {
      id
      name
    }
  }
`;

export const GET_ARENA = gql`
  query getArena($id: ID!) {
    getArena(id: $id) {
      id
      name
    }
  }
`;

export const GET_ARENA_WITH_RANGES = gql`
  query getArena($id: ID!) {
    getArena(id: $id) {
      id
      name
      ranges {
        id
        name
      }
    }
  }
`;

export const GET_RANGES = gql`
  query getRanges {
    getRanges {
      id
      name
    }
  }
`;

export const GET_RANGE = gql`
  query getRange($id: ID!) {
    getRange(id: $id) {
      id
      name
    }
  }
`;

export const GET_UNITS_BY_OWNER = gql`
  query getUnitsByOwner($ownerId: ID!) {
    getUnitsByOwner(ownerId: $ownerId) {
      id
      configJsonData {
        upgrade {
          channel
        }
      }
      statusJsonData {
        lastConnectedAt
        rangeInfo {
          name
          language
          timeZone
          installedReleaseBundle
        }
      }
    }
  }
`;

// MUTATIONS
export const CREATE_OWNER = gql`
  mutation createOwner(
    $name: String!
    $email: String
    $language: String
    $nationality: String
  ) {
    createOwner(
      name: $name
      email: $email
      language: $language
      nationality: $nationality
    ) {
      id
      name
      email
      language
      nationality
    }
  }
`;

export const UPDATE_OWNER = gql`
  mutation updateOwner(
    $id: ID!
    $name: String!
    $email: String
    $language: String
    $nationality: String
  ) {
    updateOwner(
      id: $id
      name: $name
      email: $email
      language: $language
      nationality: $nationality
    ) {
      result
      details
    }
  }
`;

export const DELETE_OWNER = gql`
  mutation deleteOwner($id: ID!) {
    deleteOwner(id: $id) {
      result
      details
    }
  }
`;

export const CREATE_ARENA = gql`
  mutation createArena($name: String!, $ownerId: ID!) {
    createArena(name: $name, ownerId: $ownerId) {
      id
      name
    }
  }
`;

export const UPDATE_ARENA = gql`
  mutation updateArena($id: ID!, $name: String!) {
    updateArena(id: $id, name: $name) {
      result
      details
    }
  }
`;

export const DELETE_ARENA = gql`
  mutation deleteArena($id: ID!) {
    deleteArena(id: $id) {
      result
      details
    }
  }
`;

export const CREATE_RANGE = gql`
  mutation createRange($name: String!, $arenaId: ID!) {
    createRange(name: $name, arenaId: $arenaId) {
      id
      name
    }
  }
`;

export const UPDATE_RANGE = gql`
  mutation updateRange($id: ID!, $name: String!, $arenaId: ID!) {
    updateRange(id: $id, name: $name, arenaId: $arenaId) {
      result
      details
    }
  }
`;

export const DELETE_RANGE = gql`
  mutation deleteRange($id: ID!) {
    deleteRange(id: $id) {
      result
      details
    }
  }
`;

export const CREATE_OWNER_ARENA_CONNECTION = gql`
  mutation createOwnerArenaConnection($ownerId: ID!, $arenaId: ID!) {
    createOwnerArenaConnection(ownerId: $ownerId, arenaId: $arenaId) {
      result
      details
    }
  }
`;

export const DELETE_OWNER_ARENA_CONNECTION = gql`
  mutation deleteOwnerArenaConnection($ownerId: ID!, $arenaId: ID!) {
    deleteOwnerArenaConnection(ownerId: $ownerId, arenaId: $arenaId) {
      result
      details
    }
  }
`;

export const CREATE_OWNER_UNIT_CONNECTION = gql`
  mutation createOwnerUnitConnection($ownerId: ID!, $unitId: ID!) {
    createOwnerUnitConnection(ownerId: $ownerId, unitId: $unitId) {
      result
      details
    }
  }
`;

export const DELETE_OWNER_UNIT_CONNECTION = gql`
  mutation deleteOwnerUnitConnection($ownerId: ID!, $unitId: ID!) {
    deleteOwnerUnitConnection(ownerId: $ownerId, unitId: $unitId) {
      result
      details
    }
  }
`;

export const CREATE_RANGE_UNIT_CONNECTION = gql`
  mutation createRangeUnitConnection($rangeId: ID!, $unitId: ID!) {
    createRangeUnitConnection(rangeId: $rangeId, unitId: $unitId) {
      result
      details
    }
  }
`;

export const DELETE_RANGE_UNIT_CONNECTION = gql`
  mutation deleteRangeUnitConnection($rangeId: ID!, $unitId: ID!) {
    deleteRangeUnitConnection(rangeId: $rangeId, unitId: $unitId) {
      result
      details
    }
  }
`;

// SUBSCRIPTIONS
export const OWNER_MODIFIED_SUBSCRIPTION = gql`
  subscription {
    ownerModified {
      action
      owner {
        id
        name
      }
    }
  }
`;
